<template>
    <div class="flex flex-col mx-14 w-full h-screen items-center justify-center">
        <div class="flex-row my-4">
            <h1>Visor de video</h1>
        </div>
        <iframe v-if="deviceName != null && cameraName != null" class="flex-row" :src="video_url_original" width="512" height="512"></iframe>
        <div class="flex-row my-4">
            <v-select class="w-full" :items="video_capacity" item-title="name" label="name" v-model="deviceName" dense>
                <template v-slot:item="{ props: itemProps, item }">
                    <v-list-item v-bind="itemProps" :subtitle="item.raw.sn"></v-list-item>
                </template>
            </v-select>
            <v-select class="w-full" :items="cameras_list" item-title="name" label="name" v-model="cameraName" dense>

                <template v-slot:item="{ props: itemProps2, item }">
                    <v-list-item v-bind="itemProps2" :subtitle="item.raw.index"></v-list-item>
                </template>
            </v-select>
            <div>
                <v-btn @click="startLive"> Play </v-btn>
                <v-btn @click="stopLive"> Stop </v-btn>
            </div>

        </div>
        <!--
        <div>
            {{ deviceSN }}
            {{ cameraIndex }}

            {{ video_url }}

        </div>
        -->
    </div>
</template>

<script setup>
/* eslint-disable */
import { onMounted } from 'vue';
import { getLiveCapacityService, startLiveService, stopLiveService, setLiveQualityService } from '../../../../services/videoService';

import { ref, computed } from 'vue';
import { CURRENT_CONFIG } from '@/api/http/config';
const VIDEO_RTMP = CURRENT_CONFIG.videriVideoRtmp;
const VIDEO_BASE = CURRENT_CONFIG.videriVideoViewer;
const video_capacity = ref([]);
const deviceName = ref(null);
const cameraName = ref(null);

onMounted(async () => {
    console.log('mounted');
    const r = await getLiveCapacityService()
    video_capacity.value = r.data
    console.warn(video_capacity.value)
});

const device = computed(() => {
    if (deviceName.value == null) {
        return null
    } else {
        return getDeviceByName(deviceName.value)
    }
})

const startLive = (() => {
    const body = startVideoBody.value;
    console.log(body)
    startLiveService(body);
}
);
const stopLive = (() => {
    const body = startVideoBody.value;
    console.log(body)

    stopLiveService(body);
}
)


const camera = computed(() => {
    if (cameraName.value == null) {
        return null
    } else {
        return getCameraByName(cameraName.value)
    }
})

const deviceSN = computed(() => {
    if (device.value == null) {
        return null
    } else {
        return device.value.sn
    }
})

const cameraIndex = computed(() => {
    if (camera.value == null) {
        return null
    } else {
        return camera.value.index
    }
})

const getDeviceByName = (name) => {
    return video_capacity.value.find((device) => device.name === name)
}

const getCameraByName = (name) => {
    return cameras_list.value.find((camera) => camera.name === name)
}

const video_id = computed(() => {
    const videoId = deviceSN.value + "/" + cameraIndex.value + "/" + "normal-0"
    return videoId
})

const video_url = computed(() => {
    const password = localStorage.getItem("password");
    const username = localStorage.getItem("username");
    const rtmpURL = VIDEO_RTMP

    const videoPath = 'original/' + deviceSN.value + '_' + cameraIndex.value + '_' + "normal-0";//this.videoSelected + "-0"
    const liveURL = rtmpURL + videoPath + '?username=' + username + '&password=' + password;
    return liveURL
})

const video_url_original = computed(() => {
    const password = localStorage.getItem("password");
    const username = localStorage.getItem("username");
    const baseURL = VIDEO_BASE

    const videoPath = 'original/' + deviceSN.value + '_' + cameraIndex.value + '_' + "normal-0";//this.videoSelected + "-0"
    const liveURL = baseURL + videoPath + '?username=' + username + '&password=' + password;
    return liveURL
})

const startVideoBody = computed(() => {
    return {
        url: video_url.value,
        video_id: video_id.value,
        url_type: 1,
        video_quality: 3
    }
})


const cameras_list = computed(() => {
    if (deviceName.value == null) {
        return []
    } else {
        const device = getDeviceByName(deviceName.value)
        return device.cameras_list
    }
})



</script>